import { render } from "./vertical.vue?vue&type=template&id=6ae0fcde&scoped=true&ts=true"
import script from "./vertical.vue?vue&type=script&lang=ts"
export * from "./vertical.vue?vue&type=script&lang=ts"

import "./vertical.vue?vue&type=style&index=0&id=6ae0fcde&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae0fcde"]])

export default __exports__